import { render } from "./Introduction.vue?vue&type=template&id=68513bf4&scoped=true"
import script from "./Introduction.vue?vue&type=script&lang=js"
export * from "./Introduction.vue?vue&type=script&lang=js"

import "./Introduction.vue?vue&type=style&index=0&id=68513bf4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-68513bf4"

export default script